/**
 * Zwraca nowy obiekt zawierający tylko wskazane (w tym zagnieżdżone) pola.
 * @param {Object} obj - oryginalny obiekt
 * @param {Object} fieldsToPick - obiekt opisujący strukturę pól do pobrania, np. {name: true, address: {city: true}}
 * @returns {Object} - nowy obiekt tylko z wybranymi polami
 */
export function pickFields(obj, fieldsToPick) {
  if (!obj || typeof obj !== 'object' || !fieldsToPick || typeof fieldsToPick !== 'object') return {};
  const result = {};
  for (const key of Object.keys(fieldsToPick)) {
    if (fieldsToPick[key] === true && key in obj) {
      result[key] = obj[key];
    } else if (
      typeof fieldsToPick[key] === 'object' &&
      fieldsToPick[key] !== null &&
      key in obj &&
      typeof obj[key] === 'object' &&
      obj[key] !== null
    ) {
      result[key] = pickFields(obj[key], fieldsToPick[key]);
    }
  }
  return result;
} 